// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__0rr28","selectedBlock":"styles_selectedBlock__fqBUq"};